import HELPER from '@/app/utils/HELPER';
import { base } from '@/app/editor/sidebar/constant';
import { app } from '@/store';
import STORE from '@/app/store/store';
import { svg } from '@/app/editor/sidebar/utils/actions.assets';
import { getProductOption, upgradeProductSettingAssign } from '@/app/utils/upgradeProductSettingAssign';
import { PRODUCT_ASSIGNMENT_EVENT } from '@/app/editor/config/constants/trackEventIds';

import {
  changeProductTitlePreview,
  getDefaultImage,
  getProductPreview,
  getProductSelectorInstance,
  getProductSelectorInstanceCallback,
} from '@/app/utils/assignedProductHelper';
import { getGlobalVariable } from '@/app/editor/config/globalVariable';
import { GET } from '@/app/api';
import api from '@/app/endpoints';

/**
 * All functions for Assigned product feature
 */
export default class AssignProduct {
  _this: any;
  $element: any;
  $gfLeftSideBar: any;
  manual_select = 'manual-select';
  assigned_product = 'assigned-products';
  assignConvertVersion = 4;

  /**
   * Constructor
   */
  constructor(_this: any, $element: any, $gfLeftSideBar: any) {
    this._this = _this;
    this.$element = $element;
    this.$gfLeftSideBar = $gfLeftSideBar;
  }

  hideSelectAssignByPageType(fields: any, keySetting: any) {
    const $gfFrame = getGlobalVariable('gfFrame');
    const pageType = $gfFrame.data('gfframe').getPageType();
    // Hiện lại product data nếu kiểu là product page
    if (pageType === 'template-product') {
      const productIndex = fields.findIndex((x: any) => x.id === 'product');
      const itemLength = fields[productIndex].items.length;
      if (itemLength > 0) {
        const options = fields[productIndex].items[0].options;
        // Trường hợp này được tạo với page type không phải product nên chỉ được append 1 option là manual select, khi sang product này cần thêm lại option assigend vào
        if (Object.keys(options).length === 1) {
          fields[productIndex].items[0].options = getProductOption(true);
        }
      }
      const visible = fields[productIndex].items[0].visible;
      if (visible === 'field-hide-all') {
        fields[productIndex].items[0].visible = '';
        app.$store.commit('editor/SET_DATA_SETTINGS', {
          id: keySetting,
          value: JSON.stringify(fields),
        });
      }
    } else {
      // Ẩn product data đi nếu không phải product page
      const productIndex = fields.findIndex((x: any) => x.id === 'product');

      const items = fields[productIndex].items ? fields[productIndex].items : undefined;
      if (items) {
        const productSelect = fields[productIndex].items[0];
        // Nếu giá trị visible của product data không có thì sẽ mặc định sẽ là ẩn `field-hide-all`, else sẽ lấy giá trị hiện tại
        const productVisible = fields[productIndex].items.length ? productSelect.visible : 'field-hide-all';

        let isUpdated = false;
        // Change to manual select if not a product page
        if (productSelect.default_value !== this.manual_select) {
          fields[productIndex].items[0].default_value = this.manual_select;
          isUpdated = true;
        }

        // Ẩn nếu hiện tại đang show
        if (productVisible !== 'field-hide-all') {
          fields[productIndex].items[0].visible = 'field-hide-all';
          isUpdated = true;
        }

        if (isUpdated) {
          app.$store.commit('editor/SET_DATA_SETTINGS', {
            id: keySetting,
            value: JSON.stringify(fields),
          });
        }
      }
    }
  }

  convertProductToAssignVersion() {
    const dataProductAssign = this.$element.attr('data-assigned-ver');
    const keySettings = HELPER.getKeyDataSetting(base._settings, this._this.getModuleId());
    const $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
    let fields: any = [];
    try {
      fields = jQuery.parseJSON($settings);
    } catch (err: any) {
      console.error(err.message);
    }

    // Trường hợp product chưa được convert lần nào
    if (!dataProductAssign || dataProductAssign != this.assignConvertVersion) {
      const pageType = STORE.getValue('__page').page.type;
      try {
        fields = upgradeProductSettingAssign(fields, pageType);
        app.$store.commit('editor/SET_DATA_SETTINGS', {
          id: keySettings,
          value: JSON.stringify(fields),
        });
        this.$element.attr('data-assigned-ver', this.assignConvertVersion);
      } catch (err: any) {
        console.error(err.message);
      }
    } else {
      this.reUpdatePidFromPickedPreview(fields, keySettings);
    }
  }

  // Trường hợp 1 product bị xóa hoặc unassigned từ nơi khác sẽ cần update lại previewId vào pId
  reUpdatePidFromPickedPreview(fields: any, keySettings: string) {
    const productIdPreview = getProductPreview();

    const pIdIndex = fields.findIndex((x: any) => x.id === 'pid');
    const pIdValue = fields[pIdIndex].default_value;

    const productIndex = fields.findIndex((x: any) => x.id === 'product');
    const productItem = fields[productIndex];

    const selected = productItem.items[0].default_value;
    if (pIdValue !== productIdPreview && selected === this.assigned_product) {
      // Update to new value
      fields[pIdIndex].default_value = productIdPreview;
      app.$store.commit('editor/SET_DATA_SETTINGS', {
        id: keySettings,
        value: JSON.stringify(fields),
      });
    }
  }

  getBackupProductId(productType: string) {
    // Change setting when change productDatatype
    let backupPid;
    if (productType === this.manual_select) {
      const fields = this._this.getSettingById('product');
      // Lấy giá trị của manual select
      backupPid = fields.items[2].default_value_id;
    } else if (productType === this.assigned_product) {
      // Get id from picked product assignment in top bar
      backupPid = getProductPreview();
    }
    return backupPid;
  }

  // Trường hợp product không có sản phẩm và select assigned
  setDefaultProductForAssigned() {
    const $gfInputField = this.$gfLeftSideBar.find('#md-settings #assigned-product');
    const smallImage = '/editor/static/icons/assign-product-no-pselected.svg';
    const productTitle = 'No product assigned';
    this.appendNoImageToSideBar($gfInputField, smallImage, productTitle);
  }

  // Trường hợp product không có sản phẩm và select manual
  setDefaultProductForManual() {
    const $gfInputField = this.$gfLeftSideBar.find('#md-settings #assign-select-product');
    const smallImage = '/editor/static/icons/assign-product-no-pselected.svg';
    const productTitle = 'No product selected';
    this.appendNoImageToSideBar($gfInputField, smallImage, productTitle);
  }

  appendNoImageToSideBar($gfInputField: JQuery, img: string, title: string) {
    setTimeout(() => {
      getProductSelectorInstanceCallback(($pProductSelector: any) => {
        let imgPreview = img;
        let titlePreview = title;
        const isProductNotFound = app.$store.getters['page/GET_IS_PRODUCT_NOT_FOUND'];
        if (isProductNotFound) {
          imgPreview = '/editor/static/icons/assign-product-no-pselected.svg';
          titlePreview = 'Product Not Found';
        }
        $pProductSelector.updateProductImageSelected(imgPreview);
        changeProductTitlePreview($gfInputField, titlePreview);
      });
    }, 0);
  }

  // Nếu shop chưa chọn product nào để preview
  isNotPickedPreview(productType: string) {
    const pPreviewIdSelected = getProductPreview();
    if (productType === this.assigned_product && pPreviewIdSelected === 'auto') {
      this.setDefaultProductForAssigned();
      return true;
    } else if (productType === this.manual_select && window._productArray.length === 0) {
      this.setDefaultProductForManual();
      return true;
    }
    return false;
  }

  updateAndChangePreviewAssignedProduct(moduleName: string, productType: string) {
    this.onOffDynamicStatus(moduleName, productType);
    const isNotPicked = this.isNotPickedPreview(productType);

    if (!isNotPicked) {
      const backupPid = this.getBackupProductId(productType);
      this.getProductToPreview(backupPid, productType);
    }
  }

  getProductToPreview(backupPid: string, productType: string) {
    // Find by id
    let product = HELPER.searchProductInList(backupPid);
    if (Object.keys(product).length == 0) {
      // Start loading
      this.startLoading();
      // Get product from server
      const data = {
        refresh: true,
        productId: backupPid,
      };
      const _this = this;
      GET(api.getProduct().url, data)
        .then((res) => {
          if (res && res.data) {
            product = res.data.product;
          }
          if (!product || !product.id) product = window._productLatest
          if (product) {
            this.updateSidebarPreview(product, productType);
            HELPER.updateProductInList(product);
          }
          _this.stopLoading();
          this._this.refresh();
        })
        .catch((err) => {
          console.log(err);
          _this.stopLoading();
        });
    } else {
      // @ts-ignore
      this.updateSidebarPreview(product, productType);
    }
  }

  updateSidebarPreview(product: any, productType: any) {
    const productId = product.id;
    this.updatePIdByAssignedProduct(productId);
    // Tách hàm ra setTimeout để tăng tốc độ xử lý.
    setTimeout(() => {
      this.changePreviewAssignedProduct(product, productType);
    }, 0);
  }

  startLoading() {
    const $pSelectorData = getProductSelectorInstance();
    if ($pSelectorData) {
      $pSelectorData.renderLoadingSkeleton(true);
    } else {
      getProductSelectorInstanceCallback(($pSelectorData: any) => {
        $pSelectorData.renderLoadingSkeleton(true);
      });
    }
  }

  stopLoading() {
    const $pSelectorData = getProductSelectorInstance();
    $pSelectorData.renderLoadingSkeleton(false);
  }

  changePreviewAssignedProduct(product: any, selectedValue: any) {
    const $mdSettings = this.$gfLeftSideBar.find('#md-settings');
    const params = { $mdSettings, selectedValue, product };
    this.changePreviewAction(params);
  }

  changePreviewAction(params: any) {
    const { $mdSettings, selectedValue, product } = params;
    // Có 2 panel ẩn phục vụ việc ẩn hiện box preview của select a product và the latest product
    // Tại 1 thời điểm chỉ có 1 box hiển thị, nên cần check type selected để append vào box đó
    const $assignProductPanel = $mdSettings.find("[data-module='assign-product']");

    if ($assignProductPanel && $assignProductPanel.length > 0) {
      const params = { selectedValue, $assignProductPanel, $mdSettings, product };
      this.changePreviewTitleAndImage(params);
    } else {
      let $assignProductPanel: any = null;
      let intervalId: any = null;
      let varCounter = 0;
      const _this = this;
      const varName = function () {
        // Chạy lại nhỏ hơn 5 lần và $pSelectorData vẫn đang chưa có giá trị
        if (varCounter <= 5 && !$assignProductPanel) {
          varCounter++;
          $assignProductPanel = $mdSettings.find("[data-module='assign-product']");
          if ($assignProductPanel) {
            const params = { selectedValue, $assignProductPanel, $mdSettings, product };
            _this.changePreviewTitleAndImage(params);
          }
        } else {
          clearInterval(intervalId);
        }
      };
      intervalId = setInterval(varName, 100);
    }
  }

  changePreviewTitleAndImage(params: any) {
    const { selectedValue, $assignProductPanel, $mdSettings, product } = params;
    const isProductNotFound = app.$store.getters['page/GET_IS_PRODUCT_NOT_FOUND'];
    if (isProductNotFound) {
      HELPER.handleProductNotFound(isProductNotFound);
      return;
    }
    let $activePanel;
    let $inputProductTitle;
    const productImage = product.image ? product.image.src : getDefaultImage();
    const pSmallImage = HELPER.getImageSmall(productImage, {
      width: 100,
      height: 100,
    });
    const productTitle = product.title;

    if (selectedValue === this.manual_select) {
      $activePanel = jQuery($assignProductPanel[1]);
      $inputProductTitle = $mdSettings.find('#assign-select-product');
    } else {
      $activePanel = jQuery($assignProductPanel[0]);
      $inputProductTitle = $mdSettings.find('#assigned-product');
    }

    const $gfInputBox = $activePanel.find('.gfInputFieldBox');
    $gfInputBox.find('.gfProductThumb').find('img').attr('src', pSmallImage);
    changeProductTitlePreview($inputProductTitle, productTitle);
  }

  onOffDynamicStatus(moduleName: string, value: string) {
    const $mdSettings = this.$gfLeftSideBar.find('#md-settings');
    if (value === this.assigned_product) {
      this._this.setDynamic(true);
      $mdSettings.attr('data-status', 'dynamic');
    } else {
      $mdSettings.attr('data-status', '');
      this._this.setDynamic(false);
    }
  }

  updatePIdByAssignedProduct(productId: number) {
    const keySettings = HELPER.getKeyDataSetting(base._settings, this._this.getModuleId());
    const $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
    let fields = [];
    try {
      fields = jQuery.parseJSON($settings);
      const fieldSize = fields.length;
      for (let i = 0; i < fieldSize; i++) {
        if (fields[i].name == 'pid') {
          fields[i].default_value = productId;
        }
      }

      app.$store.commit('editor/SET_DATA_SETTINGS', {
        id: keySettings,
        value: JSON.stringify(fields),
      });
    } catch (err: any) {
      console.log(err.message);
    }
  }

  demoProductEvents() {
    const $element = this.$element;
    $element
      .find('.gf-demo_action')
      .off('click')
      .on('click', function () {
        app.$store.dispatch('common/trackEvent', {
          eventId: PRODUCT_ASSIGNMENT_EVENT.PRODUCT_MODULE_MESSAGE_CLICKED,
        });
        app.$store.commit('page/UPDATE_IS_ASSIGN_PRODUCT_MODEL', true);
      });
  }

  renderDemoProductMessage() {
    const messageTemplate = `
      <div class="gf-demo">
        <div class="gf-demo_left">
          <div class="gf-demo_icon">
            ${svg('infoCircleFilled')}
          </div>
          <span>
            <span class='gf-demo_action'>Assign a product</span> and use this template to present it on live store
          </span>
        </div>
      </div>
    `;
    const isDynamic = this._this.isDynamicProduct();
    const isNotAssignProduct = app.$store.getters['page/GET_ASSIGNED_PRODUCT_LIST'].length === 0;
    const isShowMessage = isNotAssignProduct && isDynamic && this.$element.find('.gf-demo').length === 0;

    if (isShowMessage) {
      this.$element.find('.module').show();
      this.$element.css('position', 'relative');
      this.$element.prepend(messageTemplate);
      this.$element.find('.gf-demo').show();
    }
  }
}
